<!--suppress ALL -->
<template>
  <div class="sidebar-navigation">
    <div class="head-wrp">
      <div class="head-sn">
        <div class="media" style="align-items: center">
          <div class="media-left">
            <img :src="`/static/images/logo.png`">
          </div>
          <div class="media-content">
            <p class="title is-6">KHAS Kempek Cirebon</p>
          </div>
        </div>
        <a @click="onToggleSidebar" class="icon has-text-primary">
          <i class="fas" :class="isCollapsed ? 'fa-bars' : 'fa-chevron-left'"></i>
        </a>
      </div>
      <div class="user-intro">
        <router-link :to="`/`">
          <div class="image">
            <lazy-img class="is-rounded" is-profile :lazy-src="`/static/images/avatar/sample.jpg`">
            </lazy-img>
          </div>
        </router-link>
        <p class="title is-4 has-text-centered is-spaced">
          <router-link :to="`/`"
                       style="font-size: inherit; color: inherit">
            {{ user.profile }}
          </router-link>
        </p>
        <p class="subtitle is-6">{{getPenerimaDana(user.roles[0])}}</p>
      </div>
    </div>
    <div class="menu-wrp has-scroll" @mouseover="onHover = true"
         @mouseleave="onHover = false" :class="{'skip-scroll': !onHover}">
      <ul class="menu-list" :class="{'are-loading' : isLoading}">
        <li class="is-loading" :class="{'is-hidden' : !isLoading}"
            v-for="n in 7" :key="n"></li>
        <li v-for="(menu, index) in menus" :key="`menu-${index}`"
            :class="[{'has-sub': menu.childs.length > 0, 'is-hidden' : isLoading}, menu.classNames]">
          <template v-if="(menu.childs || []).length">
            <a class="has-icon" @click="onClickMenu(index)">
              <span class="icon"><i :class="menu.icon"></i></span>
              <span><a>{{menu.name}}</a></span>
              <span class="icon">
                <i :class="`fas fa-chevron-${menu.isActive ? 'down' : 'right'}`"></i>
              </span>
            </a>

            <div class="is-sub animated fadeIn" :class="!menu.isActive && 'is-hidden'">
              <ul class="menu-list">
                <li class="is-title-li">
                  <span>{{menu.name}}</span>
                </li>
                <li v-for="(menuChild, indexChild) in menu.childs" :key="`menu-child-${indexChild}`"
                    class="is-child" :class="menuChild.classNames">
                  <template v-if="(menuChild.childs || []).length">
                    <a class="has-icon" @click="onClickMenu(index, indexChild)">
                      <span>{{menuChild.name}}</span>
                      <span class="icon">
                        <i :class="`fas fa-chevron-${menuChild.isActive ? 'down' : 'right'}`"></i>
                      </span>
                    </a>
                    <div class="is-sub-grand-child"
                         :class="!menuChild.isActive && 'is-hidden'">
                      <ul class="menu-list">
                        <li v-for="(menuGrandChild, indexGrandChild) in menuChild.childs"
                            :key="'menu-grand-child-'+indexGrandChild">
                          <router-link @click.native="onNavigateUrl" :to="menuGrandChild.url">
                            {{menuGrandChild.name}}
                          </router-link>
                        </li>
                      </ul>
                    </div>
                  </template>
                  <router-link v-else @click.native="onNavigateUrl" class="has-icon"
                               :to="menuChild.url" :class="skipActiveLink(menuChild.url)">
                    <span class="icon"><i :class="menuChild.icon"></i></span>
                    <span>{{menuChild.name}}</span>
                  </router-link>
                </li>
              </ul>
            </div>
          </template>

          <router-link v-else @click.native="onNavigateUrl" :to="menu.url" class="has-icon">
            <span class="icon"><i :class="menu.icon"></i></span>
            <span>{{menu.name}}</span>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
  import {Component, Vue, Watch, Prop} from 'annotation';
  import Preference from '../../Preference';
  import Authentication from '../../Authentication';
  import Store from '../../util/Store';

  import User from '../../entity/User';
  import Menu from "../../entity/Menu";
  import Configuration from '../../entity/Configuration';
  import {getPenerimaDana} from "../../util/PluralVariabels";

  @Component({
    methods: {getPenerimaDana}
  })
  export default class NavigationBar extends Vue {

    @Prop({type: Boolean, default: false})
    public isLoading: boolean;

    @Prop({type: Array, default: []})
    public menus: Array<Menu>;

    public renderView: boolean = false;

    public user: User = Authentication.getUser();

    public onHover: boolean = false;

    public get isCollapsed() {
      return Preference.getSidebar();
    }

    public get settingApplication(): Configuration {
      return Store.getVmProperty('settingApplication.data', new Configuration());
    }

    @Watch('$route.path')
    public onRouteChange(val: string) {
      if (val && this.menus.length) {
        this.menus.map((menu: Menu) => {
          if (menu.childs != null && menu.childs.length > 0) {
            menu.isActive = menu.childs.some((item: Menu) => item.url === this.$route.path);
          }

          return menu;
        });
      }
    }

    public mounted() {
      const innerPage = window.$('.inner-page');

      innerPage[(Preference.getSidebar() ? 'add' : 'remove') + 'Class']('is-collapsed');

      this.$root.$on('collapse-sidebar', () => {
        if (!innerPage.hasClass('is-collapsed')) {
          innerPage.addClass('is-collapsed');
          this.onClickMenu(0, 0, true);
          Preference.setSidebar(true);

          this.$root.$emit("toggle-sidebar");
        }
      });

      window.$('.content-right').on('click', () => {
        const innerPage = window.$('.inner-page');

        if (innerPage.hasClass('is-collapsed')) {
          const hasSubCollapsed = Array.from(window.$('.is-sub')).some((item: any) => {
            return !item.classList.contains('is-hidden');
          });

          if (hasSubCollapsed) {
            this.menus = this.unCollapseAllMenu(this.menus);
          }
        }
      });
    }

    public unCollapseAllMenu(params) {
      return params.map((item: Menu) => {
        item.isActive = false;

        if (item.childs != null && item.childs.length > 0) {
          item.childs = this.unCollapseAllMenu(item.childs);
        }

        return item;
      });
    }

    public onNavigateUrl() {
      const innerPage = window.$('.inner-page');
      if (innerPage.hasClass('is-collapsed')) {
        this.menus = this.unCollapseAllMenu(this.menus);
      }
    }

    public onClickMenu(index: number, indexChild: any = null, collapseAll: boolean = false): void {
      this.menus = this.menus.map((menu: any, i: number) => {
        if (collapseAll) {
          menu.isActive = false;
          menu.childs.map((menuChild: any) => {
            menuChild.isActive = false;

            return menuChild;
          });
        } else {
          if (indexChild !== null && i === index && Array.isArray(menu.childs)) {
            menu.isActive = true;
            menu.childs.map((menuChild, iChild) => {
              menuChild.isActive = menuChild.isActive ? !menuChild.isActive : indexChild === iChild;
              return menuChild;
            });
          } else {
            menu.isActive = menu.isActive ? !menu.isActive : index === i;
          }
        }

        return menu;
      });
    }

    public beforeDestroy() {
      window.$('.content-right').off();
      window.$(window).off('resize');
    }

    public onToggleSidebar() {
      this.menus = this.unCollapseAllMenu(this.menus);
      const innerPage = window.$('.inner-page');
      innerPage.toggleClass('is-collapsed');

      Preference.setSidebar(innerPage.hasClass('is-collapsed'));

      this.$root.$emit("toggle-sidebar");
    }

    public skipActiveLink(url: string) {
      const {path, query} = this.$route;

      if (url === '/keuangan/siswa-keuangan' && path === url && Boolean(Object.keys(query).length)) {
        return 'skip-active';
      }

      return '';
    }
  }
</script>

<style lang="scss">
  @import "../../style/variables_function";

  .sidebar-navigation {
    @include fl_col;
    @include b_sh_def;
    min-height: 100vh;
    height: 100%;
    position: relative;

    .is-title-li {
      margin: -1rem -1.5rem 1rem -1.5rem;
      padding: 1.22rem 1rem;
      background-color: rgba(255, 255, 255, 0.1);
      backdrop-filter: blur(10px);
      color: white;
      display: none;

      > span {
        color: white !important;
        font-weight: 600;
        letter-spacing: 1px;
      }
    }

    .skip-active {
      background-color: transparent !important;
      color: rgba(255, 255, 255, 0.5) !important;
    }

    .head-sn, .user-intro, .menu-wrp {
      padding: .75rem;
      position: relative; // Above pseudo-overlay
      z-index: 10;
    }

    .head-sn {
      @include fl_row;
      background-color: transparent;
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);
      align-items: center;
      height: 80px;

      .media-content .title {
        color: white !important;
        font-family: 'Outfit', sans-serif;
        font-weight: 700;
      }

      a {
        width: 40px;
        height: 40px;
        margin-left: 15px;
        cursor: pointer;
        transition: .5s;
        color: rgba(255, 255, 255, 0.7) !important;
        background: rgba(255, 255, 255, 0.05);
        border-radius: 12px;
        @include fl_row(center, center);

        i {
          font-size: 1.2rem;
        }

        &:hover {
          color: white !important;
          background-color: rgba(255, 255, 255, 0.15);
        }
      }

      .media {
        flex: 1;

        img {
          height: 38px;
          width: auto !important;
          filter: drop-shadow(0 4px 6px rgba(0, 0, 0, 0.2));
        }
      }
    }

    .user-intro {
      @include fl_col;
      align-items: center;
      min-height: 190px;
      justify-content: center;
      background: transparent;
      border-bottom: 1px solid rgba(255, 255, 255, 0.08);

      .image {
        @include b_sh_def;
        margin-bottom: 1.25rem;
        border-radius: 50%;
        width: 84px;
        height: 84px;
        border: 4px solid rgba(255, 255, 255, 0.1);
        padding: 2px;
        background: rgba(255, 255, 255, 0.05);

        img {
          border: none;
          width: 100%;
          height: 100%;
          border-radius: 50%;
        }
      }

      a, i, p {
        color: white;
      }

      p.title {
        margin-bottom: .4rem;
        font-family: 'Outfit', sans-serif;
        font-weight: 700;
        letter-spacing: -0.01em;
      }

      > p:not(.title) {
        font-size: 13px;
        margin-bottom: 0;
        opacity: 0.6;
        font-weight: 500;
      }
    }

    .menu-wrp {
      flex: 1;
      min-height: calc(100vh - 330px);
      background-color: transparent;

      &.has-scroll {
        padding-right: .75rem;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 10px;
        }

        &.skip-scroll {
          padding-right: calc(4px + .75rem);
          overflow: hidden !important;
        }
      }

      > .menu-list {
        line-height: 1.75;
        padding-top: 1rem;
      }

      li, a, span, i {
        user-select: none;
      }

      ul {
        &.are-loading {
          margin-top: .75rem;
        }

        li {
          margin-bottom: 3px;

          span.icon {
            &:last-child {
              justify-content: flex-end;
              opacity: 0.5;
            }

            &:first-child {
              font-size: 1.1rem;
              width: 24px;
              opacity: 0.8;
            }
          }

          > a {
            padding: .65rem 1rem;
            border-radius: 12px;
            margin: 0 4px;
            transition: all 0.3s ease;
            border: 1px solid transparent;
          }

          a, span, i {
            color: rgba(255, 255, 255, 0.7);
            font-weight: 500;
          }

          a:hover:not(.active) {
            background-color: rgba(255, 255, 255, 0.06) !important;
            color: white !important;
            
            span, i { color: white !important; }
          }

          a.active, .is-sub ul li a.active {
            background-color: rgba(255, 255, 255, 0.15) !important;
            backdrop-filter: blur(10px);
            border-color: rgba(255, 255, 255, 0.1);
            color: white !important;
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

            span, i {
              color: white !important;
              opacity: 1;
            }
          }

          .is-sub ul {
            padding-left: 1rem;
            border-left: 0;
            margin-top: 0.35rem;
            margin-bottom: 0.35rem;

            li a {
              font-size: 0.85rem;
              padding: 0.5rem 1rem;
              border-radius: 10px;

              &:hover {
                background-color: rgba(255, 255, 255, 0.05);
                color: white;
              }
            }
          }

          > a, .is-sub ul li > a {
            font-size: .9rem;
          }
        }

        li.is-loading {
          height: 32px;
          width: 100%;
          border-radius: 10px;
          background-color: rgba(255, 255, 255, 0.05);

          & + li {
            margin-top: 12px;
          }
        }
      }
    }
  }
</style>
